import logger from 'redux-logger';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query';
import rootReducer from './root.reducer';
import pkdApi from 'store/api/pkd';
import auth0Api from 'store/api/auth0';
import initializeSlice from 'store/initialize';

const persistConfig = {
  key       : 'root',
  blacklist : [pkdApi.reducerPath, auth0Api.reducerPath, initializeSlice.name],
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer    : persistedReducer,
  devTools   : process.env.NODE_ENV !== 'production',
  middleware : (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck : false,
    }).concat([pkdApi.middleware, auth0Api.middleware]);
  },
});

setupListeners(store.dispatch);

export const persistor = persistStore(store);
